import {Component, OnInit, ViewChild} from '@angular/core';
import {UploadService} from "../shared/services/http/upload.service";
import {Config} from "../../environments/environment";
import {NotificationsService} from "angular2-notifications";
import {FormControl, FormBuilder, Validators} from "@angular/forms";
import {CustomerCategory} from "../shared/models/customer-category";
import {ReportCategory} from "../shared/models/report-category";
import {DownloadService} from '../shared/services/download-service.service';
import * as moment from 'moment';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {

  customerFormFields = (cat: CustomerCategory) => {
    return [
      {
        name: "name",
        title: "Name",
        icon: "textsms",
        control: this.fb.control(cat.name, Validators.required)
      },
      {
        name: "color",
        title: "Farbe",
        icon: "color_lens",
        type: "color",
        control: this.fb.control(cat.color, Validators.required)
      }
    ];
  };
  customerCategoryType = CustomerCategory;

  reportFormFields = (cat: ReportCategory) => {
    return [
      {
        name: "name",
        icon: "textsms",
        title:  "Name",
        control: this.fb.control(cat.name, Validators.required)
      },
    ];
  };

  reportCategoryType = ReportCategory;

  constructor(private uploadService: UploadService,
              private fb: FormBuilder,
              private notificationService: NotificationsService,
              private downloadService: DownloadService) {
  }


  ngOnInit() {

  }

  reportsUploaded(event) {
    let count = event.json()["inserted"];
    this.notificationService.success("Import abgeschlossen", count + " Berichte wurden erfolgreich importiert");
    let errors = event.json()["errors"];
    if (errors && errors.length > 0) {
      this.notificationService.error(errors.length + " Fehler aufgetreten", errors.join("\n"));
    }
  }

  customerUploaded(event) {
    let count = event.json()["count"];
    this.notificationService.success("Import abgeschlossen", count + " Kunden wurden erfolgreich importiert");
  }

  showError(event) {
    this.notificationService.error("Import fehlgeschlagen", event.json().message);
  }

  exportReports() {
    let fileName = "Report_" + moment().format("MM_DD_YYYY") + ".xlsx";
    this.downloadService.download(Config.baseUrl + "/export/reports", fileName, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
  }

}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/settings/settings.component.ts